// @ts-nocheck
import { CompositeLayer } from '@deck.gl/core';
import IconLayer from './IconLayer';
import Supercluster from 'common/utils/Cluster/Cluster';
import { UpdateParameters, Layer } from '@deck.gl/core';

import { EMPTY_OBJECT } from 'shared/constants';

const boolFn = () => true;
class IconClusterLayer extends CompositeLayer<{}> {
  static layerName: string = 'IconClusterLayer';

  constructor(props) {
    const { onClick, onPointermove, onDragStart, name } = props;
    super({
      ...props,
      onClick: ({ object }: any) => {
        if (object && object.data && onClick) {
          onClick({
            data: object.data,
            markerType: 'marker'
          });
        }
      },
      onHover: ({ object = {} }: any, event: any) => {
        if(onPointermove) {
          onPointermove({
            type: 'pointermove',
            data: object.data,
            pageX: event.offsetCenter.x,
            pageY: event.offsetCenter.y
          });
        }
      },
      onDragStart: ({ object = {} }: any, event: any) => {
        if(onDragStart) {
          onDragStart({
            type: 'dragStart',
            data: object.data,
            pageX: event.offsetCenter.x,
            pageY: event.offsetCenter.y
          });
        }
      },
      id: name
    });

    this.id = name;
  }

  shouldUpdateState({changeFlags}: UpdateParameters<Layer<{}>>) {
    return changeFlags.somethingChanged;
  }

  updateState({props, oldProps, changeFlags}: UpdateParameters<Layer<{ sizeScale: number; selectedStation: {}; clusterZoom: { max: number; min: number; }; }>>) {
    const { clusterizeItem = boolFn } = props;

    const rebuildIndex = changeFlags.dataChanged
      || !!changeFlags.propsChanged
      || props.sizeScale !== oldProps.sizeScale
      || props.selectedStation !== oldProps.selectedStation;

    if (rebuildIndex) {
      const maxZoom = props?.clusterZoom?.max ?? 8;
      const index = new Supercluster({
        minZoom: props?.clusterZoom?.min ?? 0,
        maxZoom,
        radius: 75,
        minPoints: 5
      });

      const { clusterizedItems, unclusterizedItems } = props.data.reduce((acc, item, index) => {
        const { longitude, latitude, altitude } = props.getCoordinates({ data: item, index });
        const itemData = {
          geometry: {
            coordinates: [ longitude, latitude, altitude || 0 ]
          },
          data: item,
          index,
          layerName: props.name
        };

        if (clusterizeItem({ data: item })) {
          acc.clusterizedItems.push(itemData)
        } else {
          acc.unclusterizedItems.push(itemData)
        }

        return acc;
      }, { clusterizedItems: [], unclusterizedItems: [] } as { clusterizedItems: any[]; unclusterizedItems: any[]; });

      index.load(clusterizedItems);

      this.setState({index, unclusterizedItems});

      if (props.onClusteredData) {
        const markerTrees = this._getMarkerTrees(maxZoom + 1);
        props.onClusteredData(markerTrees);
      }
    }

    const z = Math.round(this.context.viewport.zoom);
    if (rebuildIndex || z !== this.state.z) {
      const data = this.state.index.getClusters([-180, -85, 180, 85], z);
      const unclusterizedItems = this.state.unclusterizedItems;
      this.setState({
        data: [...data, ...unclusterizedItems],
        z
      });
    }
  }

  _getMarkerTrees(maxZoom: number = 0) {
    const unclusterizedItems = this.state.unclusterizedItems;

    return new Array(maxZoom).fill(0).reduce((acc,_, index) => {
      const zoomPoints = this.state.index.getClusters([-180, -90, 180, 90], index);

      acc[index] = zoomPoints.map((point) => {
        if (point.id) {
          return {
            clusterId: point.id,
            coordinates: {
              longitude: point.geometry.coordinates[0],
              latitude: point.geometry.coordinates[0]
            },
            children: [...this.state.index.getLeaves(point.id as number, 999999), ...unclusterizedItems]
          }
        }
        return point;
      });
      return acc;
    }, {} as { [key: number]: any[] });
  }

  getPickingInfo({info, mode}) {
    const pickedObject = info.object && info.object.properties;
    if (pickedObject) {
      if (pickedObject.cluster && mode !== 'hover') {
        info.objects = this.state.index
          .getLeaves(pickedObject.cluster_id, 25)
          .map(f => f.properties);
      }
      info.object = pickedObject;
    }
    return info;
  }

  renderLayers() {
    const { data } = this.state;
    const {
      id = 'cluster-icon',
      sizeScale,
      getIcon,
      pickable,
      loadOptions,
      getCoordinates
    } = this.props as any;

    return [
      new IconLayer(
        this.getSubLayerProps({
          id,
          pickable,
          sizeScale,
          data,
          getPosition: ({ data = EMPTY_OBJECT, geometry }: any, { index }: { index: number; }) => {
            const { latitude, longitude, altitude } = getCoordinates({
              data: {
                ...data,
                coordinates: {
                  latitude: geometry?.coordinates[1],
                  longitude: geometry?.coordinates[0],
                  altitude: geometry?.coordinates[2]
                }
              },
              index
            });

            return [longitude, latitude, altitude];
          },
          getIcon: ({ data, properties = {}, index }) => (
            getIcon({
              data,
              index,
              ...properties.cluster && {
                clusterWeight: properties.point_count,
                clusterId: properties.cluster_id
              }
            })
          ),
          getSize: ({ data, properties = {} }) => {
            const { height } = getIcon({
              data,
                ...properties.cluster && {
                clusterWeight: properties.point_count,
                clusterId: properties.cluster_id
              }
            });

            return height;
          },
          loadOptions,
          onIconError: (error) => {
            console.error('IconLayer error', error);
          }
        })
      )
    ];
  }
}

export default IconClusterLayer;
